<template>
  <div>
    <b-row>
      <b-col>
        <h3>{{ $t("Kullanıcı Bilgileri") }}</h3>
        <div class="mb-4"></div>
      </b-col>
    </b-row>
    <b-row v-if="user">
      <b-col sm="12" md="4">
        <b-form-group>
          <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Ad Soyad") }} <span style="color:red">*</span></legend>
          <b-form-input v-model="user.name"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Telefon") }} <span style="color:red">*</span></legend>
          <b-form-input v-model="user.phone" v-mask="'+90 (###) ### ## ##'"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">Bayi Kodu <span style="color:red">*</span></legend>
          <b-form-input v-model="user.email"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="12" class="text-right">
        <b-button @click.prevent="submit" variant="primary" :disabled="$v.$invalid">{{ $t("Ayarları Kaydet") }}</b-button>
      </b-col>
    </b-row>
    <div v-else class="w-100 text-center">
      <b-spinner />
    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'UserSettings',
    props: ['user'],
    validations: {
      user: {
        name: { required },
        phone: { required },
        email: { required },
      }
    },
    methods: {
      submit(){
        this.$emit('save-changes');
      }
    },
  }
</script>
